import { Component, Input, ElementRef, OnChanges } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-read-more',
  template: `
    <div>
      <span [innerHTML]="currentText"></span> 
      <span><a class="readMoreLink" [class.hidden]="hideToggle" (click)="toggleView()">{{ 'LEARNER_TAB.READ' | translate}} {{isCollapsed? moreTitle : lessTitle }}</a></span>
    </div>
  `,
  styleUrls: ['./read-more.component.css']
})

export class ReadMoreComponent implements OnChanges  {   

  @Input() text: string;
  @Input() maxLength: number = 100;
  currentText: string;
  hideToggle: boolean = true;

  public isCollapsed: boolean = true;
  moreTitle : string = '';
  lessTitle : string = '';

  constructor(private elementRef: ElementRef, private translate : TranslateService) {
    this.translate.get('LEARNER_TAB.MORE').subscribe(label => {
      this.moreTitle = label;
    });
    this.translate.get('LEARNER_TAB.LESS').subscribe(label => {
      this.lessTitle = label;
    });
  }
  toggleView() {
    this.isCollapsed = !this.isCollapsed;
    this.determineView();
  }
  determineView() {
    if (this.text.length <= this.maxLength) {
      this.currentText = this.text;
      this.isCollapsed = false;
      this.hideToggle = true;
      return;
    }
    this.hideToggle = false;
    if (this.isCollapsed == true) {
      this.currentText = this.text.substring(0, this.maxLength) + "...";
    } else if(this.isCollapsed == false)  {
      this.currentText = this.text;
    }

  }
  ngOnChanges() {
    this.determineView();
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/read-more/read-more.component.ts